import { render, staticRenderFns } from "./MachineDetails.vue?vue&type=template&id=87ed6b02"
import script from "./MachineDetails.vue?vue&type=script&lang=js"
export * from "./MachineDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports